import facebook from './facebook.svg';
import instagram from './instagram.svg';
import mail from './mail.svg';
import phone from './phone.svg';

export default [
  {
    name: 'Instagram',
    text: '@troncandco',
    image: instagram,
    link: 'https://www.instagram.com/troncandco/',
    target: '_blank',
  },
  {
    name: 'Facebook',
    text: 'troncandco',
    image: facebook,
    link: 'https://www.facebook.com/troncandco/',
    target: '_blank',
  },
  {
    name: 'Phone',
    text: '9829811110',
    image: phone,
    link: 'tel:+919829811110',
  },
  {
    name: 'Email',
    text: 'troncandco@gmail.com',
    image: mail,
    link: 'mailto:troncandco@gmail.com',
  },
];
